import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../../api'
import { useVideos } from '../../../VideoProvider'

export const useCampaign = (campaignId) => {
  const { videos, images, refresh } = useVideos()

  const [campaign, setCampaign] = useState()
  const [widgets, setWidgets] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        const [campaignRes, widgetsRes] = await Promise.all([
          api.get(`/campaign/get`, {
            params: {
              id: campaignId,
              limit: 1
            }
          }),
          api.get(`/campaign/widget/get`)
        ])

        if (!campaignRes.data.success && campaignId) {
          return navigate('/campaigns')
        }
        await refresh()
        let campaign = campaignRes.data.payload[0]
        const activeWidget =
          widgetsRes.data.payload && campaign.widgetId && widgetsRes.data.payload.find((w) => w.id === campaign.widgetId)
        setCampaign({ ...campaign, widget: activeWidget, videoIds: campaign.videos.map((video) => video.id) })
        if (widgetsRes) {
          setWidgets(widgetsRes.data.payload)
        }
        setIsLoading(false)
      } catch (error) {
        console.error('Error fetching campaign:', error)
        setIsLoading(false)
      }
    }

    fetchEntities()
  }, [campaignId])

  return { campaign, widgets, isLoading }
}
